import type { Record } from "@suse-o11y/record";
import type { Action, Reducer } from "redux";

export function createReducer<State>(initialState: State, reducers: Record<string, Reducer>): Reducer<State> {
	return (state: State = initialState, action: Action): State => {
		const reducer = reducers[action.type];
		return reducer ? reducer(state, action) : state;
	};
}
